import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { FC, useState } from "react";

type DialogResult = "ok" | "cancel";

type DialogProps = {
  open: boolean;
  onClose: (result: DialogResult) => void;
  message: string;
};

const MessageDialogContent: FC<DialogProps> = ({ open, onClose, message }) => {
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => onClose("cancel")}
      aria-labelledby="dialog-title"
    >
      <DialogTitle id="dialog-title">確認</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose("ok")}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};

export const useMessageDialog = () => {
  const [open, setOpen] = useState(false);
  const [resolve, setResolve] = useState<(value: DialogResult) => void>();

  const openMessageDialog = () => {
    setOpen(true);
    return new Promise<DialogResult>((resolve) => {
      setResolve(() => resolve);
    });
  };
  const onClose = (result: DialogResult) => {
    setOpen(false);
    if (resolve) {
      resolve(result);
    }
  };

  const MessageDialog: FC<{ message: string }> = (props) => (
    <MessageDialogContent
      open={open}
      onClose={onClose}
      message={props.message}
    />
  );

  return {
    MessageDialog,
    openMessageDialog,
  };
};
